export default function canSendWithoutApproval(allPermissions, targetCount, campaignType) {
  if (allPermissions.includes('manage_campaigns')) return true
  if (!allPermissions.includes('manage_small_campaigns')) return false

  const threshold = campaignType === 'email'
    ? window.ENV.SMALL_CAMPAIGN_THRESHOLD_EMAIL
    : window.ENV.SMALL_CAMPAIGN_THRESHOLD_SMS

  return targetCount <= threshold
}
